import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@ps-design-system/components/Dialog';

import LockIcon from '@ps-design-system/icons/Lock/Lock24';

const IdvModal = ({
  initiateIDVSession,
  closable,
  onClose,
  isLoading,
  open,
  onOpenChange,
  error,
  onBackClick
}) => {
  // Changes modal's open/change behaviour depend on either modal should be forcibly displayed or not
  const handleOnOpenChange = (flag) => {
    if (closable && !flag) {
      onOpenChange(flag);
      if (onClose) {
        onClose();
      }
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOnOpenChange}
    >
      <DialogContent>
        <DialogHeader style={{ paddingBottom: 0 }} showCloseButton={closable}>
          <DialogTitle className="tw-mt-0">
            <Text typeface="headline-3-m">
              <FormattedMessage
                id="idv.idv_modal.modal_title"
                defaultMessage="Complete Identity Verification"
              />
            </Text>
          </DialogTitle>
          <DialogDescription>
            <Text className="tw-flex tw-flex-gap-4 tw-items-center tw-mb-12">
              <LockIcon />
              <FormattedMessage
                id="account.stripe_intro.modal_description"
                defaultMessage="Verification by Stripe"
              />
            </Text>
            <Text>
              <FormattedMessage
                id="idv.idv_modal.verify_identity_description"
                defaultMessage="To proceed, we need to verify the identity of either the Peerspace account holder or an authorized representative on your Stripe account. This requires taking live photos of a government-issued ID (driver's license, passport, or state ID) and a selfie."
              />
            </Text>
          </DialogDescription>
          {error && <Text typeface="body-1" className="tw-text-red-800" style={{ margin: 0 }}>{error}</Text>}
        </DialogHeader>

        <DialogFooter>
          <div className="tw-flex tw-items-end tw-gap-12">
            {onBackClick &&
              <Button appearance="white" onClick={onBackClick} disabled={isLoading}>
                <FormattedMessage id="idv.idv_modal.back" defaultMessage="Back" />
              </Button>
            }
            <Button onClick={initiateIDVSession} disabled={isLoading} showSpinner={isLoading}>
              <FormattedMessage id="idv.idv_modal.continue" defaultMessage="Continue" />
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

IdvModal.propTypes = {
  initiateIDVSession: PropTypes.object,
  closable: PropTypes.bool,
  isLoading: PropTypes.bool,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onClose: PropTypes.func,
  onBackClick: PropTypes.func,
  error: PropTypes.string
};

export { IdvModal };
